import React, { Component } from "react";
import { Fade } from "react-reveal";
import "./OpensourceCharts.css";

class OpensourceCharts extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="main-div">
        <div className="os-charts-header-div">
          
        </div>
        <div className="os-charts-body-div">
          
        </div>
      </div>
    );
  }
}

export default OpensourceCharts;
